"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToCusto = exports.CreateCusto = void 0;
const components_1 = require("./classes/components");
const texts_1 = require("./classes/texts");
const data_1 = require("./classes/data");
const hook_1 = require("./classes/hook");
const tree_1 = require("./classes/helper-fns/tree");
const transformations_1 = require("./classes/helper-fns/transformations");
exports.CreateCusto = {
    Component: components_1.CustoComponent.create,
    Text: texts_1.CustoText.create,
    Data: data_1.CustoData.create,
    Hook: hook_1.CustoHook.createHook,
    Function: hook_1.CustoHook.createFn,
    hookOf: {
        Component: hook_1.CustoHook.createComponentHook,
        Text: hook_1.CustoHook.createTextHook,
        Data: hook_1.CustoHook.createDataHook,
        Hook: hook_1.CustoHook.createHookOfHook,
        Function: hook_1.CustoHook.createHookOfFn,
    },
    functionOf: {
        Component: hook_1.CustoHook.createComponentFn,
        Text: hook_1.CustoHook.createTextFn,
        Data: hook_1.CustoHook.createDataFn,
        Hook: hook_1.CustoHook.createFnOfHook,
        Function: hook_1.CustoHook.createFnOfFn,
    },
    Tree: tree_1.buildCustoTree,
};
exports.transformToCusto = {
    Hooks: transformations_1.toCustoHooks,
    Functions: transformations_1.toCustoFns,
    Texts: transformations_1.toCustoTexts,
    Components: transformations_1.toCustComponents,
};
